import classes from "./Loading.module.css";

const Loading = ({ fitHeight }) => {
  return (
    <div
      id="loadingContainer"
      className={[classes.spinnerBackdrop, fitHeight ? "" : classes.fullScreenHeight].join(" ")}
    >
      <h2>لطفا منتظر بمانید</h2>
      <h3>درحال انجام عملیات ...</h3>
      <div className={classes.spinnerContainer}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
